
export function autocomplete() {
    $("#model1").autocomplete({
        source: "/api/search/autocomplete",
        minLength: 3,
        select: function(event, ui) {
            $('#model1').val(ui.item.value);
            $('#model1ID').val(ui.item.id);
        }
    });
    $("#model2").autocomplete({
        source: "/api/search/autocomplete",
        minLength: 3,
        select: function(event, ui) {
            $('#model2').val(ui.item.value);
            $('#model2ID').val(ui.item.id);
        }
    });
}

export function addVersus() {
    $('body').on('click', '.addVersus', function(){

        if ($(this).hasClass('selected')) { // TODO : revoir, ne marche pas
            if ($(this).hasClass('selected1')) {
                removeVersus($('#versusSelected #model1'))
            }
            if ($(this).hasClass('selected2')) {
                removeVersus($('#versusSelected #model2'))
            }
            $(this).removeClass('selected').removeClass('selected1').removeClass('selected2');
            return;
        }

        var pathArray = window.location.pathname.split('/');
        var pageUri = pathArray[2];

        // if on model page show, automatically add current model as first versus
        if(pageUri === "model") {
            var model1Name = $('h1').text();
            var model1Picture = $('.carousel-item:first-child img').attr('src');
            model1Picture = getThumbnail(model1Picture);
            $('#model1').removeClass('d-none');
            $('#model1Name').text(model1Name);
            $('#model1Picture').attr('src', model1Picture);
            $('#model1 .removeVersus').hide();
        }
        // if on models page index, classically add two versus
        if (pageUri !== "model" && $('.addVersus.selected1').length === 0) {
            $('#versusSelected').removeClass('d-none');
            $(this).addClass("selected selected1");
            var model1Name = $(this).attr('data-name');
            var model1Picture = $(this).attr('data-picture');
            $('#model1').removeClass('d-none');
            $('#model1Name').text(model1Name);
            $('#model1Picture').attr('src', '/storage/models/' + getThumbnail(model1Picture));
        } else if ($('.addVersus.selected2').length === 0) {
            $('#versusSelected').removeClass('d-none');
            $(this).addClass("selected selected2");
            var model2Name = $(this).attr('data-name');
            var model2Picture = $(this).attr('data-picture');
            var model2Slug = $(this).attr('data-slug');
            $('#model2').removeClass('d-none');
            $('#model2Name').text(model2Name);
            $('#model2Picture').attr('src', '/storage/models/' + getThumbnail(model2Picture));
            var versusUrl = $('#versusLaunchButton').attr('data-href'); // base uri
            if(pageUri == "model") {
                versusUrl += '/' + pathArray[3] + '/'; // add model1
            } else {
                versusUrl += '/' + $('.selected1').attr('data-slug') + '/'; // add model1
            }
            versusUrl += model2Slug; // add model2
            $('#versusLaunchButton').attr('href', versusUrl).removeClass('d-none');
        } else { // two models are selected
            $('#versusMessage').removeClass('d-none');
        }
        if ($('.addVersus.selected1').length > 0 && $('.addVersus.selected2').length > 0) { // used when model1 remove then reselect
            versusUrl = $('#versusLaunchButton').attr('data-href') + '/' + $('.selected1').attr('data-slug') + '/' + $('.selected2').attr('data-slug'); // add model1 & model2
            $('#versusLaunchButton').attr('href', versusUrl).removeClass('d-none');
        }
    });
}

export function clickRemoveVersus() {
    $('.removeVersus').on('click', function() {
        var model = $(this).parent();
        removeVersus(model);
    });
}

export function removeVersus(model) {
    if (model) {
        // hide items in VS bar
        model.addClass('d-none');
        model.children('.modelName').text('');
        model.children('.modelPicture').attr('src', '');

        // unselect addVersus button on model card
        if (model.attr('id') == "model1") {
            $('.addVersus.selected1').removeClass('selected').removeClass('selected1');
        }
        if (model.attr('id') == "model2") {
            $('.addVersus.selected2').removeClass('selected').removeClass('selected2');
        }

        // hide VS button and VS bar when needed
        var versusUrl = $('#versusLaunchButton').attr('data-href');
        $('#versusLaunchButton').attr('href', versusUrl);
        if ($('.addVersus.selected1').length === 0 || $('.addVersus.selected2').length === 0) { // hide VS bouton
            $('#versusLaunchButton').addClass('d-none');
        }
        if ($('.addVersus.selected1').length === 0 && $('.addVersus.selected2').length === 0) { // hide versus bar
            $('#versusSelected').addClass('d-none');
        }
    }
}

export function clearVersus() {
    $('.clearVersus').on('click', function(){
        $('#versusSelected').addClass('d-none');
        $('#model1').addClass('d-none');
        $('#model2').addClass('d-none');
        $('.addVersus').removeClass("selected").removeClass("selected1").removeClass("selected2");
        $('#versusLaunchButton').attr('href', $('#versusLaunchButton').attr('data-href')).addClass('d-none');
    });
}

export function getThumbnail(picture) {
    if (picture) {
        picture = picture.replace('-1110x_',''); // if base picture is already cropped
        var thumbnail = picture.substring(0, picture.length-4);
        thumbnail = thumbnail + "-220x_.jpg";
        return thumbnail;
    }
}